
import React from 'react';
import {Link, NavLink, Route, Routes} from 'react-router-dom';

import {Disclosure} from '@headlessui/react';
import {
    BriefcaseIcon,
    CurrencyDollarIcon,
    HeartIcon,
    HomeIcon,
    InformationCircleIcon
} from '@heroicons/react/24/outline';

import {classNames} from './utils/misc';
import Home from "./components/Home";
import Money from "./components/Money";
import NotFound from "./components/NotFound";
import DeeperConnections from "./components/DeeperConnections";
import Business from "./components/Business";
import About from "./components/About";

const navigation = [
    { name: 'Home', href: '/', icon: HomeIcon },
    { name: 'Connect', href: '/connect', icon: HeartIcon },
    { name: 'Money', href: '/money', icon: CurrencyDollarIcon },
    { name: 'Business', href: '/business', icon: BriefcaseIcon },
    { name: 'About', href: '/about', icon: InformationCircleIcon },
];

function App() {
    return (
        <>
            <div className="min-h-full bg-gray-100">
                {/* Header for desktop */}
                <Disclosure as="nav" className="border-b border-gray-200 bg-white sm:block hidden">
                    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                        <div className="flex h-16 justify-between">
                            <div className="flex">
                                <div className="flex shrink-0 items-center">
                                    <img
                                        alt="Mermaid Devs"
                                        src="../logo.svg"
                                        className="h-12 w-auto"
                                    />
                                </div>
                                <div className="hidden sm:ml-6 sm:flex sm:space-x-8">
                                    {navigation.map((item) => (
                                        <NavLink
                                            key={item.name}
                                            to={item.href}
                                            aria-current={({ isActive }) => (isActive ? 'page' : undefined)}
                                            className={({ isActive }) =>
                                                classNames(
                                                    isActive
                                                        ? 'border-blue-500 text-gray-900'
                                                        : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                                                    'inline-flex items-center border-b-2 px-1 pt-1 text-sm font-medium'
                                                )
                                            }
                                        >
                                            {item.name}
                                        </NavLink>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </Disclosure>

                {/* Main Content */}
                <div className="py-10">
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/money" element={<Money />} />
                        <Route path="/business" element={<Business />} />
                        <Route path="/connect" element={<DeeperConnections />} />
                        <Route path="/about" element={<About />} />
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </div>

                {/* Mobile Bottom Navigation */}
                <nav className="fixed bottom-0 left-0 right-0 z-10 bg-white border-t border-gray-200 shadow sm:hidden">
                    <div className="flex justify-around">
                        {navigation.map((item) => (
                            <NavLink
                                key={item.name}
                                to={item.href}
                                className={({ isActive }) =>
                                    classNames(
                                        'flex flex-col items-center justify-center py-2 text-sm font-medium whitespace-pre-wrap wrap',
                                        isActive ? 'text-blue-600' : 'text-gray-500 hover:text-gray-700'
                                    )
                                }
                            >
                                <item.icon className="h-6 w-6" aria-hidden="true" />
                                <span>{item.name}</span>
                            </NavLink>
                        ))}
                    </div>
                </nav>

                <footer className="hidden sm:block bg-gray-900">
                    <div className="mx-auto max-w-7xl px-6 py-4 text-center lg:px-8">
                        <p className="mt-8 text-center text-sm/6 text-gray-400 md:order-1 md:mt-0">
                            &copy; 2025 <a href="https://mermaiddevs.com" className="text-white">Mermaid Devs Pty Ltd</a> - Made by Michelle Retzlaff
                        </p>
                    </div>
                </footer>
            </div>
        </>
    );
}

export default App;
